import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-y border-white/5" data-id="element-119">
      <div className="max-w-2xl mx-auto text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-121">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 text-gold border border-gold/30" data-id="element-122">
            <ShieldCheck className="w-8 h-8" data-id="element-123" />
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold" data-id="element-124">
            Probalo{' '}
            <span className="text-gold italic font-normal" data-id="element-125">sin riesgo</span>
          </h2>

          <p className="text-xl text-cream-muted max-w-lg mx-auto leading-relaxed" data-id="element-126">
            Probalo 7 días sin riesgo. Si no te convence, te devolvemos el
            dinero sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}